import { create } from "zustand";

interface ReportsState {
  reports: any;
  isLoading: boolean;
  setReports: (reports: any) => void;
  setIsLoading: (isLoading: boolean) => void;
  initializeReports: (userReports?: Report[]) => void;
  updateReport: (reportId: string, updates: Partial<any>) => void;
}

const useReportsStore = create<ReportsState>((set) => ({
  reports: [],
  isLoading: true,

  setReports: (reports) => set({ reports }),

  setIsLoading: (isLoading) => set({ isLoading }),

  initializeReports: (userReports) => {
    if (!userReports) {
      set({ isLoading: true });
    } else {
      set({
        reports: [...userReports].reverse(),
        isLoading: false,
      });
    }
  },

  updateReport: (reportId, updates) => {
    set((state) => ({
      reports: state.reports.map((report: any) =>
        report._id === reportId ? { ...report, ...updates } : report
      ),
    }));
  },
}));

export default useReportsStore;
